<template>
   <div class="checkout-ssrs-v2">
      <!-- SSR Type Tabs -->
      <div class="ssr-tabs">
         <button v-for="(column, columnIndex) in SSRs.columns" :key="columnIndex" class="ssr-tab" :class="{ active: activeTab === column.identifier }" @click="activeTab = column.identifier">
            <!-- <img :src="require(`@/assets/images/checkoutSsrs/${column.identifier}.svg`)" alt="" /> -->
            <span>{{ $t(`CheckoutSSRs_lbl${column.label}`) }}</span>
         </button>
      </div>

      <!-- Passengers -->
      <div class="passengers">
         <div class="passenger-box" :class="{ 'last-passenger': paxIndex === SSRs.paxes.length - 1 }" v-for="(pax, paxIndex) in SSRs.paxes" :key="paxIndex">
            <!-- Passenger Header -->
            <div class="passenger-header">
               <div class="pax-details">
                  <span class="passenger-name">{{ pax.label }}</span>
                  <span class="passenger-type">{{ pax.type }}</span>
               </div>
               <!-- Selected SSR Icons -->
               <div class="selected-ssrs" v-if="getSelectedSSRsForPax(pax).length > 0">
                  <img
                     v-for="(ssrType, idx) in getSelectedSSRsForPax(pax)"
                     :key="idx"
                     :src="require(`@/assets/images/checkoutSsrs/selected_${ssrType}.svg`)"
                     :alt="ssrType"
                     class="ssr-icon"
                     :title="ssrType" />
               </div>
            </div>

            <!-- Segments (vertical rows) -->
            <div class="segment-rows">
               <div class="segment-row" v-for="(segment, segmentIndex) in pax.segments" :key="segmentIndex">
                  <!-- Segment Route -->
                  <div class="segment-route">
                     <span class="route-from">{{ segment.departureAirportCode }}</span>
                     <img :src="`https://cdn.dev.reisetech.io/airline_34x34/${segment.airlineCode}.svg`" alt="" class="route-airline" />
                     <span class="route-to">{{ segment.arrivalAirportCode }}</span>
                  </div>

                  <!-- SSR Selection -->
                  <div class="ssr-selection">
                     <template v-if="segment.ssrs[activeTab]">
                        <div class="ssr-dropdown-wrapper" v-click-outside="closeAllDropdowns">
                           <button
                              class="ssr-button"
                              :class="{
                                 'making-selection': segment.ssrs[activeTab].makingSelection,
                                 'btn-disabled': segment.ssrs[activeTab].options.length == 0,
                                 'is-conjucted': segment.ssrs[activeTab].isConjuncted,
                                 'has-selection': segment.ssrs[activeTab].selected,
                                 'in-basket': segment.ssrs[activeTab].inBasket,
                                 'free-conjuncted': segment.ssrs[activeTab].isFreeConjuncted,
                              }"
                              @click.stop="
                                 segment.ssrs[activeTab].selected
                                    ? segment.ssrs[activeTab].isFreeConjuncted
                                       ? null
                                       : clearSSR(segment.ssrs[activeTab], activeTab, pax.id, segmentIndex + 1, flightIdentifier)
                                    : (segment.ssrs[activeTab].makingSelection = !segment.ssrs[activeTab].makingSelection)
                              "
                              :disabled="segment.ssrs[activeTab].isFreeConjuncted"
                              v-if="segment.ssrs[activeTab].isConjuncted == false || segment.ssrs[activeTab].selected">
                              <!-- Seçilmişse: V1 ile aynı yapı -->
                              <template v-if="segment.ssrs[activeTab].selected">
                                 <span v-if="segment.ssrs[activeTab].name" class="ssr-name">{{ segment.ssrs[activeTab].label }}</span>
                                 <template v-if="typeof segment.ssrs[activeTab].price == 'number'">
                                    <span class="ssr-price" v-if="segment.ssrs[activeTab].price == 0">{{ $t("CheckoutSSRs_lblFree") }}</span>
                                    <span class="ssr-price" v-else>{{ segment.ssrs[activeTab].price | price }}</span>
                                 </template>
                                 <span v-if="segment.ssrs[activeTab].isFreeConjuncted" class="ssr-free-label">{{ $t("CheckoutSSRs_lblFree") }}</span>
                                 <span v-else class="ssr-close"></span>
                              </template>
                              <!-- Seçilmemişse: yazı + + ikonu -->
                              <template v-else-if="!segment.ssrs[activeTab].isConjuncted && segment.ssrs[activeTab].options.length != 0">
                                 <span class="ssr-add-text">{{ $t("CheckoutSSRs_btnMakeSelection") }}</span>
                                 <span class="ssr-add"></span>
                              </template>
                           </button>

                           <!-- Dropdown -->
                           <template v-if="segment.ssrs[activeTab].makingSelection">
                              <ul class="ssr-dropdown">
                                 <li
                                    v-for="(option, optionIndex) in segment.ssrs[activeTab].options"
                                    :key="optionIndex"
                                    @click="selectSSR(segment.ssrs[activeTab], option, activeTab, pax.id, segmentIndex + 1, flightIdentifier)">
                                    <span class="option-name">{{ option.label }}</span>
                                    <span class="option-price">
                                       <template v-if="ssrType === 'seat'">
                                          <i> {{ option.value }} </i>|
                                       </template>
                                       {{ option.price | price }}
                                    </span>
                                 </li>
                              </ul>
                           </template>
                        </div>
                     </template>
                     <template v-else>
                        <div class="ssr-empty">-</div>
                     </template>
                  </div>
               </div>
            </div>
         </div>

         <!-- Toplam Box -->
         <div class="total-box">
            <!-- <div class="total-header">
               <span>{{ $t("CheckoutSSRs_lblTotal") }}</span>
            </div> -->

            <!-- Genel Toplam -->
            <div v-if="!showSegmentBreakdown" class="total-combined">
               <span class="total-price">{{ grandTotal | price }}</span>
            </div>

            <!-- Segment Bazlı Toplam -->
            <div v-else class="segment-rows">
               <div class="segment-row" v-for="(segment, segmentIndex) in SSRs.paxes[0].segments" :key="segmentIndex">
                  <div class="segment-route">
                     <span class="route-from">{{ segment.departureAirportCode }}</span>
                     <img :src="`https://cdn.dev.reisetech.io/airline_34x34/${segment.airlineCode}.svg`" alt="" class="route-airline" />
                     <span class="route-to">{{ segment.arrivalAirportCode }}</span>
                  </div>
                  <div class="total-amount">
                     <template v-if="ssrTotals[`${activeTab}_${segmentIndex + 1}`]?.count > 0">
                        <!-- <span class="total-count">{{ ssrTotals[`${activeTab}_${segmentIndex + 1}`].count }}x</span> -->
                        <span class="total-price">{{ ssrTotals[`${activeTab}_${segmentIndex + 1}`].price | price }}</span>
                     </template>
                     <template v-else>
                        <span class="total-empty">-</span>
                     </template>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <ul class="checkout-ssr-notes" v-if="ssrNotes.length">
         <li v-for="(note, index) in ssrNotes" :key="index">
            <template v-if="note.label">
               <strong v-if="false">{{ note.label }}:</strong> {{ note.text }}
            </template>
            <template v-else>{{ note.text }}</template>
         </li>
      </ul>
      <div class="update-basket-wrapper">
         <UIButton className="gradient_blue_pink" :text="$t('CheckoutSSRs_btnUpdateBasket')" @click.native="handlerUpdateBasket" />
      </div>
   </div>
</template>

<script>
import checkoutSSRsMixin from "@/mixins/checkoutSSRsMixin";
import UIButton from "@/components/unitary/Button.vue";

export default {
   name: "CheckoutSsrV2",
   mixins: [checkoutSSRsMixin],
   components: {
      UIButton,
   },
   props: {
      data: Object,
      flightIdentifier: String,
   },

   data() {
      return {
         showSegmentBreakdown: true,
         activeTab: null,
      };
   },

   mounted() {
      if (this.SSRs?.columns?.length > 0) {
         this.activeTab = this.SSRs.columns[0].identifier;
      }
      this.syncInitialSelections();
   },

   methods: {
      syncInitialSelections() {
         this.SSRs.paxes.forEach((pax) => {
            pax.segments.forEach((segment) => {
               Object.entries(segment.ssrs).forEach(([ssrType, ssr]) => {
                  if (ssr.selected && !ssr.isFreeConjuncted) {
                     this.$store.commit("flight/updatePaxCheckoutSSR", {
                        paxId: pax.id,
                        ssrType,
                        route: `${segment.departureAirportCode}-${segment.arrivalAirportCode}`,
                        flightIdentifier: this.flightIdentifier,
                        status: true,
                     });
                  }
               });
            });
         });
      },
   },

   computed: {},
};
</script>

<style lang="scss" scoped>
@mixin segment-route-base {
   display: flex;
   align-items: center;
   gap: 0.5rem;

   .route-from,
   .route-to {
      font-size: 16px;
      font-weight: 600;
      min-width: 30px;
   }

   .route-airline {
      width: 20px;
      height: 20px;
   }
}

.checkout-ssrs-v2 {
   // background-color: #fcfcfd;
   display: flex;
   flex-direction: column;
   // align-items: center;
   // padding: 1rem;
   width: 100%;
   box-sizing: border-box;
   overflow-x: hidden;

   // SSR Tabs
   .ssr-tabs {
      display: flex;
      gap: 0.5rem;
      margin-bottom: 0;
      z-index: 1;

      .ssr-tab {
         display: flex;
         flex-direction: column;
         align-items: center;
         gap: 0.5rem;
         padding: 0.75rem 1.5rem;
         border-top-left-radius: 1rem;
         border-top-right-radius: 1rem;
         background-color: var(--gray-0);
         border: 1px solid var(--gray-300);
         border-bottom: none !important;
         cursor: pointer;
         opacity: 0.5;
         transition: all 0.2s ease;

         img {
            $imgsize: 54px;
            width: $imgsize;
            height: $imgsize;
         }

         span {
            font-size: 15px;
            font-weight: 500;
            color: var(--gray-600);
         }

         &:hover:not(.active) {
            background-color: var(--gray-300);
         }

         &.active {
            background: var(--gray-100);
            border: 1px solid var(--gray-300);
            // background: linear-gradient(90deg, rgba(40, 135, 210, 1) 0%, rgba(146, 90, 222, 1) 100%);
            opacity: 1 !important;

            span {
               // color: #fff;
               font-weight: 600;
            }
         }
      }
   }

   // Passengers
   .passengers {
      display: flex;
      flex-direction: column;
      // gap: 1rem;
      width: 100%;
      margin-top: -1px;
      // background-color: var(--gray-100);
      border: 1px solid var(--gray-300);
      // padding: 1rem;
      padding-top: 0.5rem !important;
      border-radius: 0 1rem 1rem 1rem;

      .passenger-box {
         display: flex;
         flex-direction: column;
         gap: 1rem;
         border-bottom: 6px solid var(--gray-200);
         // background-color: var(--gray-100);

         padding: 1rem;
         background-color: var(--gray-100);
         border-radius: 1rem;
         margin: 0.5rem 0.75rem;

         &.last-passenger {
            border-bottom: none !important;
         }
      }

      .passenger-box,
      .total-box {
         // background-color: var(--gray-0);
         // border: 1.5px solid var(--gray-200);
         // border-radius: 1rem;
         padding: 1rem;

         .passenger-header {
            display: flex;
            gap: 1rem;
            align-items: center;
            padding-bottom: 0.5rem;
            border-bottom: 1px solid var(--gray-200);
            margin-top: 0;
         }

         .passenger-header,
         .total-header {
            // min-width: 160px;
            margin-top: 10px;

            .pax-details {
               display: flex;
               flex-direction: column;
               line-height: 1.2rem;

               .passenger-name {
                  font-size: 16px;
                  font-weight: 600;
               }

               .passenger-type {
                  font-size: 14px;
                  color: var(--gray-600);
               }
            }

            span {
               font-size: 16px;
               font-weight: 600;
               color: var(--gray-700);
            }

            .gts-icon {
               cursor: pointer;
               font-size: 18px;
               transition: color 0.2s ease;

               &:hover {
                  color: var(--blue-600);
               }
            }

            .selected-ssrs {
               margin-top: 0.5rem;
               display: flex;
               // display: none !important;
               gap: 0.25rem;
               flex-wrap: wrap;

               .ssr-icon {
                  $ssrIconSize: 36px;
                  width: $ssrIconSize;
                  height: $ssrIconSize;
                  opacity: 1;
                  transition: opacity 0.2s ease;

                  &:hover {
                     opacity: 1;
                  }
               }
            }
         }

         .segment-rows {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            width: 100%;

            .segment-row {
               display: flex;
               align-items: center;
               justify-content: space-between;
               border-radius: 0.5rem;

               @media (max-width: 1200px) {
                  flex-direction: column;
                  align-items: flex-start;
               }
               // background-color: var(--gray-50);

               .segment-route {
                  @include segment-route-base;
               }

               .ssr-selection {
                  flex: 1;
                  display: flex;
                  justify-content: flex-end;
                  max-width: 200px;

                  @media (max-width: 1200px) {
                     max-width: unset;
                  }

                  .ssr-empty {
                     text-align: center;
                     color: var(--gray-400);
                     font-size: 18px;
                  }

                  .ssr-dropdown-wrapper {
                     position: relative;
                  }

                  .ssr-dropdown {
                     position: absolute;
                     top: calc(100% + 6px);
                     left: 50%;
                     transform: translateX(-50%);
                     background: var(--gray-0);
                     border: 1px solid var(--gray-200);
                     border-radius: 0.75rem;
                     box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
                     min-width: 180px;
                     z-index: 10;
                     max-height: 300px;
                     overflow-y: auto;

                     li {
                        display: flex;
                        flex-direction: column;
                        padding: 0.5rem 0.75rem;
                        cursor: pointer;
                        transition: background-color 0.15s ease;
                        border-bottom: 1px solid var(--gray-200);

                        &:hover {
                           background-color: var(--blue-50);
                        }

                        .option-name {
                           font-weight: 500;
                           font-size: 14px;
                        }

                        .option-price {
                           font-size: 13px;
                           color: var(--gray-600);
                           font-weight: 600;
                        }
                     }
                  }

                  .ssr-button {
                     display: flex;
                     flex-direction: row;
                     align-items: center;
                     justify-content: space-between;
                     width: 100%;
                     height: 42px;
                     border-radius: 1rem;
                     background-color: var(--gray-0);
                     border: 1px solid var(--gray-300);
                     line-height: 1.25rem;
                     font-weight: 600;
                     font-size: 14px;
                     gap: 0.5rem;
                     padding: 0 1rem;
                     min-width: 200px;

                     @media (max-width: 1200px) {
                        // min-width: unset;
                     }

                     &.btn-disabled {
                        cursor: not-allowed;
                     }

                     &.is-conjucted {
                        position: relative;

                        // &::before,
                        // &::after {
                        //    content: "";
                        //    position: absolute;
                        //    top: -8px;
                        //    display: block;
                        //    width: 8px;
                        //    height: 8px;
                        //    background: #f2f4f7;
                        // }

                        // &::before {
                        //    left: 10px;
                        // }

                        // &::after {
                        //    right: 10px;
                        // }
                     }

                     &.has-selection {
                        background-color: var(--blue-100);
                        color: var(--blue-700);

                        &.in-basket {
                           background-color: var(--green-100);
                           color: var(--green-700);

                           .ssr-price {
                              color: var(--green-800);
                           }

                           .ssr-free-label {
                              color: var(--green-800) !important;
                           }
                        }

                        &.free-conjuncted {
                           background-color: var(--blue-100);
                           color: var(--blue-700);
                           cursor: not-allowed;
                           opacity: 0.85;

                           &.in-basket {
                              background-color: var(--green-100);
                              color: var(--green-700);
                           }

                           .ssr-free-label {
                              font-size: 14px;
                              font-weight: 900;
                              margin-top: 2px;
                              color: var(--blue-800);
                           }

                           .ssr-price {
                              display: none;
                           }
                        }
                     }

                     &.making-selection {
                        background-color: var(--blue-100);

                        .ssr-add {
                           background-color: var(--blue-600);
                        }
                     }

                     .ssr-add,
                     .ssr-close {
                        width: 32px;
                        height: 32px;
                        background-color: var(--gray-600);
                        border-radius: 50%;
                        position: relative;

                        &::before,
                        &::after {
                           content: "";
                           position: absolute;
                           background-color: #fff;
                           border-radius: 1px;
                        }

                        &::before {
                           width: 14px;
                           height: 2px;
                           top: 50%;
                           left: 50%;
                           transform: translate(-50%, -50%);
                        }

                        &::after {
                           width: 2px;
                           height: 14px;
                           top: 50%;
                           left: 50%;
                           transform: translate(-50%, -50%);
                        }
                     }

                     .ssr-add-text {
                        font-size: 16px;
                        font-weight: 500;
                        color: var(--gray-700);
                     }

                     .ssr-close {
                        opacity: 1;
                        position: static;
                        transform: none;
                        background-color: var(--gray-600);
                        flex-shrink: 0;

                        &::before {
                           transform: translate(-50%, -50%) rotate(-45deg) !important;
                           top: 50%;
                           left: auto;
                        }

                        &::after {
                           transform: translate(-50%, -50%) rotate(-45deg) !important;
                           top: 50%;
                           left: auto;
                        }
                     }

                     .ssr-name {
                        font-weight: 700;
                        font-size: 14px;
                     }

                     .ssr-price {
                        font-size: 16px;
                        font-weight: 900;
                        color: var(--blue-800);
                     }
                  }
               }
            }
         }
      }

      .total-box {
         display: flex;
         justify-content: flex-end;
         // align-items: center;
         padding: 0.5rem 1rem;
         background: linear-gradient(90deg, rgba(40, 135, 210, 0.125) 0%, rgba(146, 90, 222, 0.125) 100%);
         border-bottom-left-radius: 1rem;
         border-bottom-right-radius: 1rem;

         .total-header {
            display: flex;
            align-items: flex-start;
            gap: 0.5rem;
            margin-right: 1rem;

            span {
               font-size: 15px;
               font-weight: 600;
               color: var(--gray-700);
            }

            .gts-icon {
               cursor: pointer;
               font-size: 18px;
               transition: color 0.2s ease;

               &:hover {
                  color: var(--blue-600);
               }
            }
         }

         .total-combined,
         .segment-rows {
            // padding: 0.5rem 1.25rem;
            // min-width: 200px;
            // padd
         }

         .total-combined {
            display: flex;
            align-items: center;
            justify-content: center;

            .total-price {
               font-size: 20px;
               font-weight: 700;
               color: var(--gray-700);
            }
         }

         .segment-rows {
            display: flex;
            flex-direction: column;
            gap: 0.4rem;

            .segment-row {
               display: flex;
               align-items: center;
               justify-content: space-between;
               gap: 1rem;

               .segment-route {
                  @include segment-route-base;
               }

               .total-amount {
                  display: flex;
                  align-items: center;
                  gap: 0.4rem;

                  .total-count {
                     display: none;
                     font-size: 14px;
                     color: var(--blue-700);
                  }

                  .total-price {
                     font-size: 18px;
                     font-weight: 800;
                     color: var(--gray-700);
                  }

                  .total-empty {
                     min-height: 28px;
                     color: var(--gray-400);
                  }
               }
            }
         }
      }
   }
}

.checkout-ssr-notes {
   display: flex;
   flex-direction: column;
   background-color: var(--yellow-100);
   border: 1.5px solid var(--yellow-300);
   padding: 0.5rem 1rem;
   border-radius: 1rem;
   width: 100%;
   margin-top: 0.5rem;
   margin-bottom: 0.5rem;
   box-sizing: border-box;

   li {
      font-size: var(--small);
      strong {
         font-weight: 500;
      }
   }
}

.update-basket-wrapper {
   margin-top: 1rem;
}
</style>
